import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

export default function AuthRegister() {
  const { register, status, error } = useAuth();
  const history = useHistory();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const username = form.email || form.phone;
    const result = await register({ ...form, username });
    if (result.ok) history.push("/market-data");
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.2fr 0.8fr" },
        gap: 3,
        alignItems: "center",
      }}
    >
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
        <Stack spacing={2.5}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                background: isDark
                  ? "rgba(56,189,248,0.2)"
                  : "rgba(37,99,235,0.12)",
              }}
            >
              <PersonAddOutlinedIcon />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                Create your member account
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                Access deeper analytics with email or phone verification.
              </Typography>
            </Box>
          </Stack>

          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Full name"
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Email"
                value={form.email}
                onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Phone number"
                value={form.phone}
                onChange={(e) => setForm((prev) => ({ ...prev, phone: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Password"
                type="password"
                value={form.password}
                onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
                fullWidth
              />
              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={status === "loading"}
              >
                Create account
              </Button>
              {error ? (
                <Typography variant="body2" sx={{ color: "error.main" }}>
                  {error}
                </Typography>
              ) : null}
            </Stack>
          </form>

          <Divider />
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Already a member? <Link to="/login">Sign in here</Link>.
          </Typography>
        </Stack>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: isDark
            ? "1px solid rgba(251,191,36,0.35)"
            : "1px solid rgba(14,116,144,0.25)",
          background: isDark
            ? "linear-gradient(160deg, rgba(30,41,59,0.9), rgba(15,23,42,0.7))"
            : "linear-gradient(160deg, rgba(248,250,252,0.95), rgba(255,255,255,0.9))",
        }}
      >
        <Stack spacing={2}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Member highlights
          </Typography>
          {[
            "Premium allocation engine",
            "Goal timeline stress testing",
            "ETF basket rebalancer",
            "Priority market briefings",
          ].map((item) => (
            <Stack key={item} direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: isDark ? "#fbbf24" : "#0f766e",
                }}
              />
              <Typography variant="body2">{item}</Typography>
            </Stack>
          ))}
          <Button component={Link} to="/" variant="text" sx={{ alignSelf: "flex-start" }}>
            Explore free view first
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
